import { useEffect } from "react";
import TermlyEmbed from "./TermlyEmbed";

const TermsOfUse = () => {
  useEffect(() => {
    document.title = "Terms of Use | Kloudscan";
  }, []);

  return <TermlyEmbed policyId="13073079-42c2-43e9-8471-dfb55dbcbbad" label="Terms of Use" />;
};

export default TermsOfUse;
